import { Component, Input, OnInit } from '@angular/core';
import { SnapshotResponseDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { MoConnectFormInstanceOptionComponent } from '../mo-connect-form-instance-option/mo-connect-form-instance-option.component';

@Component({
    selector: 'tc-mo-connect-form-simulation-option',
    templateUrl: './mo-connect-form-simulation-option.component.html',
    styleUrls: ['./mo-connect-form-simulation-option.component.scss'],
    standalone: false
})
export class MoConnectFormSimulationOptionComponent
  extends MoConnectFormInstanceOptionComponent
  implements OnInit
{
  private _snapshot: SnapshotResponseDto;
  get snapshot(): SnapshotResponseDto {
    return this._snapshot;
  }
  @Input() set snapshot(value: SnapshotResponseDto) {
    this._snapshot = value;
    if (this.snapshot) {
      this.snapshotLabel = this.masterOperatorService.snapshotReadableLabel(this.snapshot);
    }
  }

  snapshotLabel: string;

  ngOnInit(): void {}
}
